module.exports = __webpack_public_path__ + "img/scheduled_messages.15ccf148.svg";